import apiClient from '@/services/axios'

export async function put(partnershipId, payload) {
  var response = await apiClient.put('/partnerships/' + partnershipId, payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update Partnership.')
}
